const CATEGORIES = ['配信数', '経由売上', '獲得売上'];
const FIELDS = ['session_count', 'conversion_price', 'contribution_price'];
const SEGMENTS = {
  pc: 'PC',
  sp: 'スマートフォン',
  tablet: 'タブレット',
};

angular.module('zc')
  .component('zcSiteReportDeviceSegment', {
    templateUrl: '/templates/projects.site_reports/device_segment.html',
    bindings: { project: '<' },
    controller: zcSiteReportDeviceSegment,
  });

zcSiteReportDeviceSegment.$inject = ['$scope', 'ChartV2', 'barChartV2Config'];
function zcSiteReportDeviceSegment($scope, ChartV2, barChartV2Config) {
  const vm = this;

  $scope.$watch('$ctrl.project', project => {
    if(!project.thisMonthStat) return;
    setChartConfig();
  });

  function setChartConfig() {
    let categories;
    let fields;
    if(vm.project.is_abtest) {
      categories = CATEGORIES;
      fields = FIELDS;
    } else {
      categories = CATEGORIES.slice(0, -1);
      fields = FIELDS.slice(0, -1);
    }
    const chart = new ChartV2(barChartV2Config, { xAxis: { categories } });
    vm.chartConfig = chart.getConfig();
    const segments = _.sortBy(vm.project.thisMonthStat.devices, segment => {
      if(!segment.device) return -1; // Move to the last
      return segment.session_count;
    });
    _.each(segments, segment => {
      const name = SEGMENTS[segment.device] || '不明';
      const data = _.map(fields, field => _.get(segment, field));
      chart.addSeries({ stacking: 'percent', name, data });
    });
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.site_reports/device_segment.controller.js